module.exports = __webpack_public_path__ + "img/HA.1260d468.png";